// extracted by mini-css-extract-plugin
export var button = "fp-xl";
export var buttonDarkmode = "fp-Kl";
export var buttonDisabled = "fp-Fl";
export var buttonFullWidth = "fp-El";
export var buttonLoading = "fp-Gl";
export var buttonPrimary = "fp-Hl";
export var buttonPrimarySmall = "fp-Ml";
export var buttonSecondary = "fp-Il";
export var buttonSmall = "fp-Ll";
export var buttonTertiary = "fp-Jl";
export var button__child = "fp-Ol";
export var button__loadingIcon = "fp-Nl";
export var ctaButton__icon = "fp-Pl";
export var grid = "fp-yl";
export var gridWithRowGap = "fp-zl";
export var maxWidthContainer = "fp-Dl";
export var mt0 = "fp-ql";
export var mt1 = "fp-rl";
export var mt2 = "fp-sl";
export var mt3 = "fp-tl";
export var mt4 = "fp-ul";
export var mt5 = "fp-vl";
export var mt6 = "fp-wl";
export var removeVisuallyHidden = "fp-Bl";
export var visuallyHidden = "fp-Al";
export var widgetBase = "fp-Cl";